import { createSlice } from "@reduxjs/toolkit";
import {
  createAcquirer,
  getAcquirerById,
  updateAcquirer,
  getCurrencies,
} from "./AcquirerForm.thunk";

const steps = ["Acquirer Info", "Acquirer Commissions", "Bank Info"];

const baseState = {
  acquirerData: null,
  acquirerId: null,
  activeStep: 0,
  steps,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusRetrieve: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCurrencies: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  errorRetrieve: null,
  errorCurrencies: null,
  currencies: [],
  acquirerLoadId: null,
};

const initialState = {
  ...baseState,
};

export const acquirerFormSlice = createSlice({
  name: "acquirerForm",
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      const { payload } = action;
      state.activeStep = payload;
    },
    setActiveLoadId: (state, action) => {
      const { payload } = action;
      state.acquirerLoadId = payload;
    },
    ResetStore: (state) => {
      state.status = "idle";
      state.statusRetrieve = "idle";
      state.error = null;
      state.errorRetrieve = null;
      state.acquirerData = null;
      state.acquirerId = null;
      state.activeStep = 0;
      state.currencies = [];
      state.acquirerLoadId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAcquirer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createAcquirer.fulfilled, (state, action) => {
        // const { enrollmentData, page, page_size, total_pages, total_records } =
        //   action.payload;
        state.status = "succeeded";
      })
      .addCase(createAcquirer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error creating acquirer";
      });
    builder
      .addCase(getAcquirerById.pending, (state) => {
        state.statusRetrieve = "loading";
      })
      .addCase(getAcquirerById.fulfilled, (state, action) => {
        const { acquirerData, acquirerId } = action.payload;

        state.acquirerData = { ...acquirerData };
        state.acquirerId = acquirerId;
        state.statusRetrieve = "succeeded";
      })
      .addCase(getAcquirerById.rejected, (state, action) => {
        state.statusRetrieve = "failed";
        state.errorRetrieve =
          action.payload?.message || "Error creating acquirer";
      });
    builder
      .addCase(updateAcquirer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAcquirer.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.acquirerId = null;
        state.acquirerData = null;
      })
      .addCase(updateAcquirer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error updating acquirer";
      });
    builder
      .addCase(getCurrencies.pending, (state) => {
        state.statusCurrencies = "loading";
      })
      .addCase(getCurrencies.fulfilled, (state, action) => {
        state.currencies = action.payload.currencies;
        state.statusCurrencies = "succeeded";
      })
      .addCase(getCurrencies.rejected, (state, action) => {
        state.statusCurrencies = "failed";
        state.errorCurrencies =
          action.payload?.message || "Error getting currencies";
      });
  },
});

export const { ResetStore, setActiveStep, setActiveLoadId } =
  acquirerFormSlice.actions;

export default acquirerFormSlice.reducer;
